import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

/**
 * Get paginated list of antifraud notifications
 * @param {Object} params - Query parameters
 * @param {number} params.limit - Items per page (1-500, default 100)
 * @param {number} params.offset - Items to skip (default 0)
 * @param {string} params.sort - Sort field:direction (default 'created_at:desc')
 * @returns {Promise<Object>} { data, pagination, links }
 */
export async function getAntifraudNotifications(params = {}) {
    const response = await axiosRequest({
        url: constants.URL.ANTIFRAUD_NOTIFICATIONS,
        method: METHOD.GET,
        requestName: 'GET ANTIFRAUD NOTIFICATIONS',
        params: params,
        isLoader: false,
    });

    return response == null
        ? {
              data: [],
              pagination: {
                  total: 0,
                  limit: constants.PAGINATION.DEFAULT_LIMIT,
                  offset: 0,
                  count: 0,
              },
              links: {
                  self: null,
                  first: null,
                  prev: null,
                  next: null,
                  last: null,
              },
          }
        : response;
}
